export default "__VITE_ASSET__d3c62cfa__"